import { FC } from 'react';
import {
  VStack,
  FormControl,
  Select,
  Input,
  Checkbox,
  CheckboxGroup,
  HStack,
  Radio,
  RadioGroup,
  Wrap,
} from '@chakra-ui/react';
import {
  Control,
  Controller,
  UseFormRegister,
  UseFormSetValue,
  UseFormWatch,
} from 'react-hook-form';

import { FormFieldTypes, FormFiled } from '../../../../models';
import { getConditionOperator } from '../../utils';
import { ConditionalNodeData } from '../../models';

export const ConditionFieldDate: FC<{
  conditionField: FormFiled;
  control: Control<ConditionalNodeData>;
  register: UseFormRegister<ConditionalNodeData>;
  watch: UseFormWatch<ConditionalNodeData>;
  setValue: UseFormSetValue<ConditionalNodeData>;
}> = ({ control, register, watch, setValue, conditionField }) => {
  return (
    <VStack>
      <FormControl flexBasis="50%" mt="2">
        <Select {...register('conditionOperation')}>
          <option />
          {getConditionOperator(conditionField).map(value => (
            <option value={value} key={value}>
              {value}
            </option>
          ))}
        </Select>
      </FormControl>

      {watch('conditionOperation') &&
        !['empty', 'not empty'].includes(
          watch('conditionOperation') as string
        ) &&
        conditionField.type !== FormFieldTypes.separator && (
          <FormControl flexBasis="50%" mt="2">
            {![
              FormFieldTypes.singleSelection,
              FormFieldTypes.multipleSelection,
            ].includes(conditionField.type) && (
              <Input
                type={
                  conditionField.type === FormFieldTypes.date ? 'date' : 'text'
                }
                {...register('conditionValue1')}
              />
            )}

            {conditionField.type === FormFieldTypes.multipleSelection && (
              <CheckboxGroup
                colorScheme="orange"
                onChange={value => {
                  setValue('conditionValue1', value.join(', '));
                }}
              >
                <HStack>
                  <Wrap>
                    {conditionField.options?.map(option => (
                      <Checkbox key={option.title} value={option.title}>
                        {option.title}
                      </Checkbox>
                    ))}
                  </Wrap>
                </HStack>
              </CheckboxGroup>
            )}

            {conditionField.type === FormFieldTypes.singleSelection && (
              <Controller
                control={control}
                name="conditionValue1"
                render={({ field }) => (
                  <FormControl>
                    <RadioGroup colorScheme="orange" {...field}>
                      <HStack>
                        {conditionField.options?.map(option => (
                          <Radio key={option.title} value={option.title}>
                            {option.title}
                          </Radio>
                        ))}
                      </HStack>
                    </RadioGroup>
                  </FormControl>
                )}
              />
            )}
          </FormControl>
        )}

      {conditionField.type === FormFieldTypes.date &&
        watch('conditionOperation') === 'between' && (
          <FormControl flexBasis="50%" mt="2">
            <Input type="date" {...register('conditionValue2')} />
          </FormControl>
        )}
    </VStack>
  );
};
